(function() {
	'use strict';

	angular.module('quantixApp').factory('GenericService', GenericService);

	GenericService.$inject = [ '$resource', '$q', '$http', '$window'];
	function GenericService($resource, $q, $http, $window) {
		var accessDataObject={
			"userSectionAccessData":null,
			"userModuleAccessData":null
		};

		function getModuleAndSectionData(accessData) {
			var url = 'api/userActivity/getModuleAndSectionFlag';
			if(accessDataObject[accessData]!=null){
				const defered=$q.defer();
				defered.resolve(accessDataObject[accessData]);
				return defered.promise;
			}
			return	$http.post(url).then(function (response) {
					onSuccess(response);
					return accessDataObject[accessData]
			});			
		}

		function onSuccess(response){
			var result = response.data;
			accessDataObject['userSectionAccessData'] = result.sectionWiseAccess;
			accessDataObject['userModuleAccessData'] = angular.toJson(result.moduleWiseAccess);
			const modAccessLength = Object.keys(result.moduleWiseAccess).length;
			$window.localStorage.modlength = Object.keys(result.moduleWiseAccess).length;

			if (modAccessLength === 0) {
				$sessionStorage.logImage = true;
				ErrorHandlerService
						.forbiddenError('FORBIDDEN');
				return;
			}
        };
		var factory = {};

		factory.getZonalLocationDetailsdata = function() {
			var deferred = $q.defer();
			if ($window.localStorage['locationtreedata'] != null
					&& $window.localStorage['locationtreedata'].length != 0) {
				deferred.resolve(JSON
						.parse($window.localStorage['locationtreedata']));
			} else {

				var url = 'api/masterData/getZonalLocationTreeList';
				$http.post(url /* ,{ignoreLoadingBar: true} */).then(
						function(response) {
							deferred.resolve(response.data);
						}, function(response) {
							deferred.reject(response);
						});
			}
			return deferred.promise;
		}
		
		
		factory.getAlternateTreeData = function(industryCategory) {
			   var deferred = $q.defer();	
			   var urlAppend = '';
			   if(industryCategory == 'AMFI'){
				   urlAppend = 'amfiindustry';
			   }else if(industryCategory == 'BSE'){
				   urlAppend = 'bseindustry';
			   }else if(industryCategory == 'IRS'){
				   urlAppend = 'irsindustry';
			   }else if(industryCategory == 'RBI'){
				   urlAppend = 'rbiindustry';
			   } 
			

				var url = 'api/masterData/getAlternateIndustry/'+urlAppend;
				$http.get(url).then(
						function(response) {
							deferred.resolve(response.data);
						}, function(response) {
							deferred.reject(response);
						});
			
			return deferred.promise;
		}

		factory.getMasterIndustryTreeDatascorecard = function() {

			var deferred = $q.defer();
			var url = 'api/masterData/getMasterIndustryTreeData';
			$http.post(url /* ,{ignoreLoadingBar: true} */).then(
					function(response) {
						deferred.resolve(response.data);
					}, function(response) {
						deferred.reject(response);
					});
			return deferred.promise;
		}

		factory.getUserSectionAccessData = function () {
			var data=getModuleAndSectionData('userSectionAccessData');
			return data.then(function(result){
				return JSON.parse(result);
			});
		}

		factory.getUserModuleAccessData = function () {
			var data=getModuleAndSectionData('userModuleAccessData');
			console.log('Data : ',data);
			return data.then(function(result){
				return JSON.parse(result);
			});
		}

		factory.getIndustryTreeData = $resource(
				'api/masterData/getIndustryTreeList', {
					data : '@data'
				}, {
					'getIndustryTree' : {
						method : 'GET',
						isArray : true,
						transformResponse : function(data) {
							var myData = [];
							myData.push(data);
							return myData;
						}
					}
				});

		factory.getMasterIndustryTreeData = $resource(
				'api/masterData/getMasterIndustryTreeData', {}, {
					'industryList' : {
						method : 'POST',
						isArray : true,
						transformResponse : function(data) {
							var myData = [];
							myData.push(data);
							return myData;
						}
					}
				});
		
		
		factory.getMasterProductTreeData = function() {
			var deferred = $q.defer();
			if ($window.localStorage['producttreedata'] != null
					&& $window.localStorage['producttreedata'].length != 0) {

				deferred.resolve(JSON
						.parse($window.localStorage['producttreedata']));
			} else {

				var url = 'api/masterData/getMasterProductTreeData';
				$http.post(url /* ,{ignoreLoadingBar: true} */).then(
						function(response) {
							deferred.resolve(response.data);
						}, function(response) {
							deferred.reject(response);
						});
			}
			return deferred.promise;
		}

		factory.getCompaniesListByName =$resource(
				'api/masterData/getCompaniesByName', {
					searchText : '@searchText'
				}, {
					'companiesList' : {
						method : 'GET',
						isArray : true,
						transformResponse : function(data) {
							var myData = [];
							myData.push(data);
							return myData;
						}
					}
				});
		factory.getSelectBoxData = function(){
			var deferred = $q.defer();
			var url = 'api/getSelectboxdata/getData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}
				factory.getUserSettingsData = function(){
			var deferred = $q.defer();
			var url = 'api/getUsersettingsData/getData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
			
		}
				factory.saveUserSettingsData = function(userData) {
			return $http({
				method : 'POST',
				url : 'api/saveUserSettingsData/setData',
				headers : {
					'Content-type' : 'application/json'
				},
				data : userData
			}).success(function(data) {

			}).error(function(data) {

			});
		}

		factory.getuserData = function(){
			var deferred = $q.defer();
			var url = 'api/getuserConfigurationData/getData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
			
		}
		
		factory.getScreeningToolSectorAndSizeList = function(){
			var deferred = $q.defer();
			var url = 'api/masterData/getScreeningToolSectorAndSizeList';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
			
		}

		factory.getScoreCardSpreadSheetData = $resource(
				'api/getScoreCrdSheet/getData', {}, {
					'getData' : {
						method : 'GET',
						// isArray : true,
						transformResponse : function(data) {
							data = JSON.parse(data);

							return data;
						}
					}
				});
		factory.getsegmentData = $resource('api/getsegmentData/getData', {}, {
			'getData' : {
				method : 'GET',
				isArray : true,
				transformResponse : function(data) {
					data = JSON.parse(data);
					return data;
				}
			}
		});

		factory.getIndustryTreeDataModuleWise = $resource(
				'api/masterData/getIndustryTreeListForSelectedModule', {
					moduleName : '@moduleName'
				}, {
					'getIndustryTree' : {
						method : 'GET',
						isArray : true,
						ignoreLoadingBar : true,
						transformResponse : function(data) {
							var myData = [];
							myData.push(data);
							return myData;
						}
					}
				});

		factory.getLongTermCreditRatingData = function() {

			var deferred = $q.defer();
			var url = 'api/masterData/getLongTermCreditRatingData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		factory.getShortTermCreditRatingData = function() {

			var deferred = $q.defer();
			var url = 'api/masterData/getShortTermCreditRatingData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		factory.getMaximumRevenuLimit = function() {

			var deferred = $q.defer();
			var url = 'api/masterData/getMaximumRevenuLimit';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		factory.getMutualFundMasterData = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getMutualFundMasterData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		factory.getInvestmentTypeData = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getInvestmentTypeData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		factory.getMaturityTypeData = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getMaturityTypeData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		factory.getTreasuryBenchmarkData = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getTreasuryBenchmarkData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		factory.getInvestmentCategoryTree = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/getInvestmentCategoryTree';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		// Financial data add by Rahul 

		factory.getMasterFinacialIndustryTreeDatascorecard = function() {

			var deferred = $q.defer();
			var url = 'api/masterData/getFinancialMasterIndustryTreeData';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}
	
	
	factory.updateDownloadStatusForRRCRRreport = function(fd) {

		var deferred = $q.defer();
		var url = 'api/RRCRRReport/updateDownloadFlagOfRRAndCRR';
		$http.post(url,fd,{
			transformRequest : angular.identity,
			responseType : 'arraybuffer',
			headers : {
				'Content-Type' : undefined,
			}
		}).then(function(response) {
			deferred.resolve(response.data);
		}, function(response) {
			deferred.reject(response);
		});
		return deferred.promise;
	}
	


	factory.upadateUserInfo = function(registerAgainsDepartment) {
		var deferred = $q.defer();
		var url = 'api/firstTimeLoginStatus';
		$http.post(url, registerAgainsDepartment).then(function(response) {
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});

		return deferred.promise;
	}
	
	factory.getUserViewedCount = function(fd){
		var deferred = $q.defer();
		var url =  'api/usage';		
		
		$http.get(url, {
			params : fd,
			ignoreLoadingBar : true
		}).then(function(response) {
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});

		return deferred.promise;
	}
	
	factory.getIrsIndustryName = function(){

		var deferred = $q.defer();
		var url =  'api/masterData/getIrsIndustryNameList';		
		$http.post(url).then(function(response) {	
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});
		return deferred.promise;
	
		
	}
	
	factory.getMasterBankTreeData = function(){

		var deferred = $q.defer();
		var url =  'api/masterData/getMasterBankTreeDataQuery';		
		$http.post(url).then(function(response) {	
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});
		return deferred.promise;
	
		
	}
	
	factory.getMasterSegmentWiseTreeData = function(segmentName){

		var deferred = $q.defer();
		var url =  'api/masterData/getSegmentWise';		
		$http.post(url,segmentName).then(function(response) {	
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});
		return deferred.promise;
	
		
	}
	
	factory.getMasterTreeData = function(segmentName){

		var deferred = $q.defer();
		var url =  'api/masterData/getAllSegments';		
		$http.post(url,segmentName).then(function(response) {	
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});
		return deferred.promise;
	
		
	}
	factory.trackUsage=function(searchQuery,moduleName){
		var formData = {
			'module':moduleName,
			'searchQuery': searchQuery
		};
		$http.put('api/usage',formData,{
			headers:{
				"Content-Type": "application/json"
			},
			ignoreLoadingBar : true
		});
	}
	factory.insertIncrementalUser = function() {
		var deferred = $q.defer();
		var url = 'api/savecompanyinfoadmin';
		$http.post(url, {
			responseType : 'application/json',
		}).then(function(response) {
			deferred.resolve(response.data);
		}, function(response) {
			deferred.reject(response);
		});
		return deferred.promise;
	}
	factory.getLatestIrsIndustryName = function(){

		var deferred = $q.defer();
		var url =  'api/masterData/getLatestIrsIndustryNameList';		
		$http.post(url).then(function(response) {	
			deferred.resolve(response.data);
		}, function(errResponse) {
			deferred.reject(errResponse);
		});
		return deferred.promise;
	
		
	}
	
	return factory;
}
})();
